<template>
    <header class="header">
        <div class="header_box">
            <div class="logo_div">
                <img class="logo1" src="https://zyprogram.xinchacha.com/xiansuo/logo1.png" alt="" @click="gozz"/>
                <img src="https://zyprogram.xinchacha.com/xiansuo/pc/logo.png" alt="" @click="goindex"/>
            </div>
            <div class="query-box">
                <div class="btn" @click="goPage('/vipMember')">
                    <img src="https://zyprogram.xinchacha.com/xiansuo/pc/vip_img.png" alt="" srcset="">
                </div>

                <div class="loginBtn" v-if="isLogin == 0" @click="openProp">登陆/注册</div>
                <div class="myList" v-if="isLogin != 0 && form != null">
                    <span class="sj-class">
                        <img v-if="form.image !='' && form.image !=null" :src="form.image" alt="" srcset="">
                        我的
                    </span>
                    <div class="head_dh_xialai">
                        <img src="https://zyprogram.xinchacha.com/assets/img/icon/sin.png" alt="" srcset="">
                        <p @click="goMyFn(1)">我的关注</p>
                        <p @click="goMyFn(2)">我的订单</p>
                        <p @click="goMyFn(3)">我的发票</p>
                        <p @click="goMyFn(4)">我的企业</p>
                        <p @click="goMyFn(5)">会员信息</p>
                        <p @click="goMyFn(9)">我的下载</p>
                        <p @click="goMyFn(6)">个人信息</p>
                        <!-- <p @click="goMyFn(9)">我的合同</p> -->
                        <p @click="goMyFn(7)">设置密码</p>
                        <p @click="exitFn">退出登录</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="prop_class" v-if="loginType == 1">
            <div class="window_div">
                <div class="tabs_box">
                    <div :class="[loginTabsType == 1? 'tabs_box_item click':'tabs_box_item']" @click="loginTabsType = 1">短信登录|注册</div>
                    <div :class="[loginTabsType == 2? 'tabs_box_item click':'tabs_box_item']" @click="loginTabsType = 2">密码登录</div>
                </div>

                <div class="from_dom" v-if="loginTabsType == 2">
                    <el-form :model="ruleForm" class="demo-ruleForm">
                        <el-form-item>
                            <el-input v-model.number="ruleForm.username" autocomplete='off' class="input_txt" placeholder="请输入手机号"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input type="password" autocomplete="off" v-model="ruleForm.password" class="input_txt" placeholder="请输入密码"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="from_dom" v-else>
                    <el-form :model="fromRule" class="demo-ruleForm">
                        <el-form-item>
                            <el-input v-model.number="fromRule.username" autocomplete='off' class="input_txt" placeholder="请输入手机号"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="imgVer" class="input_txt" placeholder="请输入图片验证码">
                                <el-button class="yzmbtn" slot="append" @click="changeImage">
                                    <img v-if="smsImage != ''" style="height: 30px;vertical-align: middle;" :src="smsImage" alt="">
                                    <span v-else>图片验证码</span>
                                </el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="fromRule.smsCode" class="input_txt" placeholder="请输入短信验证码">
                                <el-button class="yzmbtn" slot="append" @click="getYzm">
                                    <template v-if="sending">
                                        获取验证码
                                    </template>
                                    <template v-else>
                                        {{second}}秒后重发
                                    </template> 
                                </el-button>
                            </el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="from_btn" @click="loginFn()">
                    立即登录
                </div>
                <div class="close_btn" @click="clearProp">
                    <i class="el-icon-close"></i>
                </div>
                <!-- <a href="" target="_blank"></a> -->
            </div>
        </div>
    </header>
</template>
<script>
export default {
    name:'vHeader',
    data(){
        return{
            loginType:2,
            loginTabsType:2,
            ruleForm:{
                username:'',
                password:'',
				device:1
            },
            fromRule:{
                username:'',
                smsCode:'',
				device:1
            },
            imgVer:"",
            smsImage:"",
            sending: true,      //是否发送验证码
            disabled: false,   //是否禁发验证码
            second:60,
            form:null,
            isLogin:0
        }
    },
    methods:{
        gozz(){
            window.location.href = 'https://www.xcc.cn/'
        },
        openProp(){
            document.addEventListener('mousewheel', this.hander, false);
            this.loginType = 1;
        },
        clearProp(){
            document.removeEventListener('mousewheel', this.hander, false);
            this.loginType = 2;
            this.imgVer = '';
            this.smsImage = '';
        },
        hander(e) {
            e.preventDefault()
        },
        goindex(){
            window.onscroll = function(){}
            return this.$router.push({
                path:'/index'
            });
        },
        changeImage(){
            var _this = this;
            var phoneReg = /^[1][0-9][0-9]{9}$/;
            if (!phoneReg.test(this.fromRule.username)) {
                this.$message.error("请输入正确的手机号")
                return
            }
            this.$axios({
                method: 'get',
                url: this.$posh + "api/sms/getImageCode?phone=" + this.fromRule.username
            }).then((res)=>{
                _this.smsImage = res.data;
            })
        },
        getYzm(){
            if(!this.sending){
                return
            };
            if (this.imgVer == '') {
                this.$message.error("请填写图片验证码")
                return
            };
            if (this.fromRule.username.toString().length == 11) {
                var _this = this;
                var url = 'api/sms/sendSms?phone='+this.fromRule.username+'&imgVar='+this.imgVer
                this.getRequest(url).then((res)=>{
                    var data = res.data;
                    if(data.status == 200){
                        _this.sending = false;      //是否发送验证码
                        _this.disabled = true;      //是否禁发验证码
                        _this.countDown();          //倒计时
                    }
                })
            } else {
                this.$message.error("您的账号格式错误")
            }
        },
        countDown () {
            let result = setInterval( ()=>{
                --this.second;
                if(this.second < 0){
                    clearInterval(result);
                    this.sending  = true;
                    this.disabled = false;
                    this.second = 60;
                };
            }, 1000);
        },
        loginFn(){
            if (this.loginTabsType == 2) {
                this.getdengluFn();
            } else {
                this.getZuceFn();
            }
        },
        goPage(url){
            return this.$router.push({
                path:url
            });
        },
        setCookie(c_name,value,expiredays) {  
		    var exdate=new Date();  
		    exdate.setDate(exdate.getDate()+expiredays);
		    document.cookie=c_name+ "=" +escape(value)+((expiredays==null) ? "" : ";expires="+exdate.toGMTString())+";path=/;domain=xcc.cn";  
		},
        getdengluFn(){
            var _this = this;
            var cc = this.isUsername();
            if(cc == true){
                var _this = this;
                this.postRequest('api/user/login',this.ruleForm).then((res)=>{
                    var data = res.data;
                    if (data.status == 200) {
                        var token = data.obj.jwt;
                        var userId = data.obj.username;
                        localStorage.setItem('token',token);
                        localStorage.setItem('userId',userId);
                        var iS_VIP = data.obj.IS_VIP;
                        localStorage.setItem("is_Vip", iS_VIP);
                        if(data.obj.IS_CLUE_VIP != ''){
                            localStorage.setItem("clueVip",data.obj.IS_CLUE_VIP);
                        }
                        
                        _this.setCookie('token',token);
                        _this.setCookie('userId',userId);
                        _this.setCookie('is_Vip',iS_VIP);
                        _this.setCookie('aaa',JSON.stringify(data));

                        _this.clearProp();
                        window.location.reload()
                        _this.getInfo();
                    }else{
                        _this.$message.error(data.msg);
                    }
                })
            }else{
                this.$message.error("您的账号格式错误")
            }
        },
        getZuceFn(){
            // alert('登录/注册')''
            var cc = this.isUsername();
            if (cc == true) {
                var _this = this;
                this.postParamDun('api/user/phoneLogin',this.fromRule).then((res)=>{
                    var data = res.data;
                    if (data.status == 200) {
                        var token = data.obj.jwt;     //获取token
                        var userId = data.obj.username;     //获取userId
                        localStorage.setItem('token',token);  // 缓存token
                        localStorage.setItem('userId',userId);  // 缓存userId
                        var iS_VIP = data.obj.IS_VIP;
                        localStorage.setItem("is_Vip", iS_VIP);
                        if(data.obj.IS_CLUE_VIP != ''){
                            localStorage.setItem("clueVip",data.obj.IS_CLUE_VIP);
                        }
                        
                        _this.setCookie('token',token);
                        _this.setCookie('userId',userId);
                        _this.setCookie('is_Vip',iS_VIP);
                        _this.setCookie('aaa',JSON.stringify(data));
                        _this.clearProp();
                        window.location.reload()
                        _this.getInfo();
                    }else{
                        _this.$message.error(data.msg);
                    }
                })
            } else {
                this.$message.error("您的账号格式错误")
            }
        },
        isUsername(){
            var username = '';
            
            if (this.loginTabsType == 2) {
                username = this.ruleForm.username;
            }else{
                username = this.fromRule.username;
            }
            var retType = true;
            var myreg=/^[1][0-9][0-9]{9}$/;
            if(myreg.test(username) != true){
                retType = false; 
            }
            return retType
        },
        getInfo(){
            var _this = this;
            this.getRequest('api/personalInfo/getPersonalInfo').then((res)=>{
				var data = res.data;
				if(data.status == 200){
					if (data.obj != null){
						var userId = localStorage.getItem('userId');
                        if(userId == undefined || userId == '' || userId == null){
							userId = '登录/注册';
						}
						_this.form = data.obj;
                        _this.isLogin = 1;
                        var type = data.obj.vipEndTime;
                        if (type != null) {
                            localStorage.setItem('Vip',1);  // vip 状态是
                        } else {
                            localStorage.setItem('Vip',2);  // vip 状态否
                        }
                    }
                }
            })
        },
        exitFn(){
            var _this = this;
            this.$confirm('是否退出账号', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                _this.getRequest('api/user/logOut',{}).then(res=>{
                    var data = res.data;
                    if (data.status == 200) {
                        _this.isLogin = 0;
                        _this.$message.success('退出');
                        localStorage.removeItem('userId');
                        localStorage.removeItem('token');
                        localStorage.removeItem('is_Vip');
                        localStorage.removeItem('clueVip');
                        localStorage.removeItem('Vip');
                        _this.clearCookie();
                    }
                })
                
            }).catch(() => {});
        },
        goMyFn(a){
            var is_Vip = localStorage.getItem('is_Vip');
            var Vip = localStorage.getItem('Vip');
            var userId = localStorage.getItem('userId');
            var token = localStorage.getItem('token');
            if(a == 1){
                var url = 'https://www.xcc.cn/myContent?id=1&is_Vip='+is_Vip+'&Vip='+Vip+'&userId='+userId+'&token='+token;
                window.open(url);
            }else if(a == 2){
                var url = 'https://www.xcc.cn/myContent?id='+a+'&is_Vip='+is_Vip+'&Vip='+Vip+'&userId='+userId+'&tabs=4&token='+token;
                window.open(url);
            }else if(a == 3){
                var url = 'https://www.xcc.cn/myContent?id='+a+'&is_Vip='+is_Vip+'&Vip='+Vip+'&userId='+userId+'&token='+token;
                window.open(url);
            }else if(a == 4){
                var url = 'https://www.xcc.cn/myContent?id='+a+'&is_Vip='+is_Vip+'&Vip='+Vip+'&userId='+userId+'&token='+token;
                window.open(url);
            }else if(a == 5){
                var url = 'https://www.xcc.cn/myContent?id='+a+'&is_Vip='+is_Vip+'&Vip='+Vip+'&userId='+userId+'&token='+token;
                window.open(url);
            }else if(a == 9){
                var url = 'https://www.xcc.cn/myContent?id='+a+'&is_Vip='+is_Vip+'&Vip='+Vip+'&userId='+userId+'&token='+token;
                window.open(url);
            }else if(a == 6){
                var url = 'https://www.xcc.cn/myContent?id='+a+'&is_Vip='+is_Vip+'&Vip='+Vip+'&userId='+userId+'&token='+token;
                window.open(url);
            }else if(a == 7){
                var url = 'https://www.xcc.cn/myContent?id='+a+'&is_Vip='+is_Vip+'&Vip='+Vip+'&userId='+userId+'&token='+token;
                window.open(url);
            }
        },
        getCookie(name){
			var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
			if (arr = document.cookie.match(reg)){
				return unescape(arr[2]);
            }else{
				return "";
            }
		},
        clearCookie(){
			var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
			if (keys) {
				for (var i = keys.length; i--;) {
					document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString();//清除当前域名下的,例如：m.xcc.cn
					document.cookie = keys[i] + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString();//清除当前域名下的，例如 .m.xcc.cn
					document.cookie = keys[i] + '=0;path=/;domain=xcc.cn;expires=' + new Date(0).toUTCString();//清除一级域名下的或指定的，例如 .xcc.cn
				}
			}
		},
    },
    mounted(){
        var _this = this;
	    var userId = localStorage.getItem('userId');
        if (userId == null) {
            
        } else {
            this.isLogin = 1;
            this.getInfo();
        }
        var cookieUserId = this.getCookie('userId');
        var useridStorage = localStorage.getItem('userId');
// 		if(cookieUserId == "" && useridStorage != null){
//             _this.getRequest('api/user/logOut',{}).then(res=>{
//                 var data = res.data;
//                 if (data.status == 200) {
//                     localStorage.removeItem('userId');
//                     localStorage.removeItem('token');
//                     localStorage.removeItem('is_Vip');
//                     localStorage.removeItem('aaa');
//                     localStorage.removeItem('clueVip');
//                     localStorage.setItem('Vip',2);
//                     _this.clearCookie();
//                     _this.islogin = null;
//                     _this.$router.push('/')
//                 }
//             })
//         }
//         if (cookieUserId != "" && useridStorage == null){
//             var iS_VIP = this.getCookie('is_Vip');
//             var token = this.getCookie('token');
//             var userId = this.getCookie('userId');
//             var aaa = JSON.parse(this.getCookie('aaa'));
//             localStorage.setItem("is_Vip", iS_VIP);
//             localStorage.setItem('token',token);  // 缓存token
//             localStorage.setItem('userId',userId);  // 缓存userId
//             if(aaa.obj.IS_CLUE_VIP != ''){
//                 localStorage.setItem("clueVip",aaa.obj.IS_CLUE_VIP);
//             }
//             _this.getInfo();
//         }
    }
}
</script>
<style scoped>
.input_txt>>>.el-input__inner{
    height: 60px;
    font-size: 20px;
}
.input_txt>>>.el-input-group__append{
    background-color: #409EFF;
}
</style>
<style lang="scss" scoped>
.yzmbtn{
    width: 120px;
    font-size: 16px;
    color: #fff !important;
}
.header{
    width: 100%;
    height: auto;
    background-color: #fff;
    box-shadow: 0px 0px 30px #dfdfdf;
    >div.header_box{
        height: 88px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        @media screen and (max-width: 1400px){
            width: 960px;
        }
        @media screen and (min-width: 1400px){
            width: 1200px;
        }
        >div.logo_div{
            width: auto;
            height: 88px;
            line-height: 80px;
            >img.logo1{
                margin-right: 10px;
            }
            >img{
                width: auto;
                height: 58px;
                vertical-align: middle;
            }
        }
        >div.query-box{
            width: 50%;
            height: 88px;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            >div.btn{
                width: auto;
                height: 24px;
                cursor: default;
                >img{
                    width: auto;
                    height: 24px;
                    display: block;
                }
            }
            >div.loginBtn{
                width: 120px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                border-radius: 6px;
                color: #fff;
                font-size: 16px;
                background-color: #4192FE;
                margin-left: 40px;
                cursor: default;
            }
            >div.myList{
                width: auto;
                height: 50px;
                line-height: 50px;
                font-size: 16px;
                margin-left: 20px;
                position: relative;
                >span.sj-class{
                    background-image: url(https://zyprogram.xinchacha.com/assets/headicon/xia.png);
                    background-repeat: no-repeat;
                    background-position: 100% 50%;
                    padding-right: 20px;
                    >img{
                        width: 30px;
                        height: 30px;
                        vertical-align: middle;
                        border-radius: 50%;
                    }
                }
                .head_dh_xialai{
                    width: 140px;
                    height: auto;
                    position: absolute;
                    top: 48px;
                    left: -20%;
                    background: #ffffff;
                    padding-top: 10px;
                    padding-bottom: 10px;
                    border-radius: 6px;
                    display: none;
                    z-index: 9999;
                    box-shadow: 0px 0px 10px #cdcdcd;
                    >img{
                        width: 20px;
                        height: 10px;
                        position: absolute;
                        top: -10px;
                        left: 56px;
                    }
                    >p{
                        width: 120px;
                        height: 39px;
                        line-height: 39px;
                        border-bottom: 1px solid #eeeeee;
                        font-size: 14px;
                        color: #333333;
                        cursor:default;
                        margin: 0 auto;
                        text-align: center;
                    }
                }
            }
            >div.myList:hover >.head_dh_xialai{
                display: block;
            }
        }
    }
}

.prop_class{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    background-color: rgba($color: #000000, $alpha: 0.4);
    >div.window_div{
        width: 600px;
        height: auto;
        margin: 6% auto 0;
        padding-top: 80px;
        padding-bottom: 80px;
        box-sizing: border-box;
        background-color: #FFFFFF;
        position: relative;
        >div.tabs_box{
            width: 420px;
            height: 50px;
            display: flex;
            justify-content: space-between;
            margin: 0 auto 35px;
            >div.tabs_box_item{
                width: auto;
                height: 49px;
                line-height: 50px;
                font-size: 20px;
                color: #666666;
                cursor: default;
            }
            >div.tabs_box_item.click{
                border-bottom: 1px solid #3396FB;
                color: #3396FB;
                font-weight: 600;
            }
        }
        >div.from_dom{
            width: 420px;
            height: auto;
            margin: 0 auto;
            .demo-ruleForm{
                width: 100%;
                height: auto;
                
            }
        }
        >div.from_btn{
            width: 420px;
            height: 60px;
            line-height: 60px;
            background: #409EFF;
            font-size: 20px;
            font-weight: 600;
            color: #FFFFFF;
            text-align: center;
            margin: 50px auto 0;
        }
        >div.close_btn{
            position: absolute;
            top: 20px;
            right: 20px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/header.vue